<template>

  <div id="app">

  <transition
    name="v03"
    :duration="400"
  >

    <the-navigation
      v-if="navIsOpen"
      @hide="onHideNav"
    ></the-navigation>

  </transition>

    <router-link
      to="/career"
      :class="{ 'caption_work-with-us-white' : isMainPage || navIsOpen }"
      class="caption caption_work-with-us"
    >Work with us</router-link>

    <button
      @click="onClickNavSwitch"
      :class="navSwitchClasses"
      class="button button_nav-switch"
    >
      <span class="button__line"></span>
      <span class="button__line"></span>
      <span class="button__line"></span>
    </button>

    <router-link
      to="/"
      exact
      :class="logoClasses"
      class="logo logo_default"
    >
    
      <div class="logo__image"></div>
    
      <div class="logo__caption">Trade<br>marketing</div>
    
    </router-link>

    <router-view
      @switchNavSwitch="onSwitchNavSwitch"
      @switchLogo="onSwitchLogo"
      @hideFooter="onHideFooter"
      @showFooter="onShowFooter"
    ></router-view>

    <the-footer
      ref="footer"
      :class="{ 'footer_main-page' : isMainPage }"
    ></the-footer>

    <the-notification></the-notification>

  </div>

</template>

<script>
  import Utils from '@/mixins/Utils';

  import TheFooter from '@/components/TheFooter';
  import TheNavigation from '@/components/TheNavigation';
  import TheNotification from '@/components/TheNotification';

  export default {
    name: 'App',

    components: {
      TheFooter,
      TheNavigation,
      TheNotification,
    },

    mixins: [
      Utils,
    ],

    data() {
      return {
        navIsOpen: false,
        variantLogo: null,
        variantNavSwitch: null,
      };
    },

    computed: {
      logoClasses() {
        let cssClass = null;

        switch (this.variantLogo) {
          case 1:
            cssClass = 'logo_white';
            break;

          case 2:
            cssClass = 'logo_short';
            break;
        }

        return cssClass;
      },

      navSwitchClasses() {
        let cssClass = null;

        if (this.isMainPage && !this.isMobile && !this.navIsOpen) {
          if (this.variantNavSwitch === 1) {
            cssClass = 'button_nav-switch-white';
          }
        } else if (this.isMainPage && this.isMobile && !this.navIsOpen) {
          cssClass = 'button_nav-switch-white';
        } else if (this.navIsOpen) {
          cssClass = 'button_nav-close-button';
        }

        return cssClass;
      },

      isMainPage() {
        return this.$route.name === 'Main';
      },
    },

    watch: {
      $route() {
        // Track a virtual page
        gaTrack(this.$route.path, '4MKTG — For Marketing');
        ga('send', 'pageview');

        if (this.navIsOpen) {
          this.hideNav();
        }
      },
    },

    methods: {
      onClickNavSwitch() {
        this.navIsOpen = !this.navIsOpen;
      },

      hideNav() {
        this.navIsOpen = false;
      },

      onSwitchLogo(options) {
        const {
          variant: variantLogo,
        } = options;

        this.variantLogo = variantLogo;
      },

      onSwitchNavSwitch(options) {
        const {
          variant: variantNavSwitch = 0,
        } = options;

        this.variantNavSwitch = variantNavSwitch;
      },

      onHideNav() {
        this.hideNav();
      },

      onHideFooter() {
        const footerNode = this.$refs.footer.$el;

        footerNode.classList.add('footer_hide');
      },

      onShowFooter() {
        const footerNode = this.$refs.footer.$el;

        footerNode.classList.remove('footer_hide');
      },
    },
  };
</script>

<style src="./styles/global.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue